export default __webpack_public_path__ + "static/media/749.f345786b.png";